import { render, staticRenderFns } from "./accessNotAllowed.vue?vue&type=template&id=a6f0c27c"
import script from "./accessNotAllowed.vue?vue&type=script&lang=js"
export * from "./accessNotAllowed.vue?vue&type=script&lang=js"
import style0 from "./accessNotAllowed.vue?vue&type=style&index=0&id=a6f0c27c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports